import React from 'react';

function PillButton({ label, className, type, ...restProps }) {
  return (
    <button className={className} type={type} {...restProps}>
      {label}
    </button>
  );
}

export default PillButton;
